module.exports = __webpack_public_path__ + "static/flags/NG-fbeeee22e82a3b0ac000435d40bccc68.gif";